import React from 'react';
import { motion } from 'framer-motion';
const prices = [{
  service: 'Move-Out / Move-In Cleaning',
  price: 'starting at $180'
}, {
  service: 'Deep Cleaning',
  price: 'starting at $220'
}, {
  service: 'Post-Construction Cleaning',
  price: 'starting at $350'
}, {
  service: 'Commercial Cleaning',
  price: 'starting at $350/month'
}, {
  service: 'Airbnb Turnover Cleaning',
  price: 'custom quote',
  highlight: true
}];
export function Pricing() {
  return <section id="pricing" className="py-32 bg-paper relative border-t border-concrete/30" data-id="element-161">
      <div className="container mx-auto px-8 lg:px-12 max-w-4xl" data-id="element-162">
        <div className="text-center mb-20" data-id="element-163">
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-164">
            <div className="w-8 h-[1px] bg-lime" data-id="element-165"></div>
            <span className="text-ink/50 font-body text-xs uppercase tracking-[0.3em]" data-id="element-166">
              Investment
            </span>
            <div className="w-8 h-[1px] bg-lime" data-id="element-167"></div>
          </div>
          <h2 className="text-4xl md:text-5xl text-ink font-light mb-6" data-id="element-168">
            Transparent <span className="font-medium" data-id="element-169">Pricing.</span>
          </h2>
          <p className="text-ink/60 font-light text-sm" data-id="element-170">
            No hidden fees. Just premium service.
          </p>
        </div>

        <div className="flex flex-col" data-id="element-171">
          {prices.map((item, index) => <motion.div key={item.service} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`flex flex-col sm:flex-row sm:items-end justify-between py-6 border-b border-concrete/50 group ${item.highlight ? 'text-ink' : 'text-ink/80'}`} data-id="element-172">
              <span className={`text-lg tracking-wide ${item.highlight ? 'font-medium' : 'font-light'}`} data-id="element-173">
                {item.service}
              </span>
              <div className="hidden sm:block flex-grow border-b border-dotted border-concrete/50 mx-6 mb-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-174"></div>
              <span className={`text-xs uppercase tracking-[0.2em] mt-2 sm:mt-0 ${item.highlight ? 'text-lime font-medium bg-ink px-3 py-1' : ''}`} data-id="element-175">
                {item.price}
              </span>
            </motion.div>)}
        </div>

        <div className="mt-20 text-center" data-id="element-176">
          <p className="text-ink/50 text-xs font-light mb-8 max-w-md mx-auto leading-relaxed" data-id="element-177">
            Prices vary based on square footage, condition, and specific
            architectural requirements.
          </p>
          <a href="#quote" className="inline-block bg-ink text-paper px-10 py-4 text-xs uppercase tracking-[0.2em] hover:bg-graphite transition-colors" data-id="element-178">
            Get Your Custom Quote
          </a>
        </div>
      </div>
    </section>;
}